<template>
  <div class="main-content">
    <div>
      <v-dialog v-model="modalProdutos" width="65%">
        <v-card>
          <v-card-title>
            Visualizar Produtos
          </v-card-title>
          <v-card-text>
            <v-data-table
              v-model="produtosSelecionados"
              :headers="headersProdutos"
              :items="produtos.data"
              :items-per-page="9999999"
              :single-select="false"
              item-key="nota_itens_id"
              show-select
              hide-default-footer
              hide-action
            >
              <template v-slot:item.emissao="{ item }">
                {{ item.emissao | formatData }}
              </template>
              <template v-slot:item.valor_antigo="{ item }">
                {{ item.valor_antigo | formatCurrency }}
              </template>
              <template v-slot:item.valor_unit_atual="{ item }">
                {{ item.valor_unit_atual | formatCurrency }}
              </template>
              <template v-slot:item.prod_vprod="{ item }">
                {{ item.prod_vprod | formatCurrency }}
              </template>
              <template v-slot:item.total_atual="{ item }">
                {{ item.total_atual | formatCurrency }}
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="primary" @click="repetirPedido" :disabled="!produtosSelecionados.length">
              <v-icon class="mr-1">
                mdi-repeat
              </v-icon>
              Repetir Pedido com os itens selecionados
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card>
        <v-card-title>Pesquisar Clientes</v-card-title>
        <v-card-text>
          <v-form autocomplete="off">
            <v-row class="pb-3" style="max-width: 600px" no-gutters>
              <v-text-field
                autofocus
                @keydown.enter.prevent="pesquisarClientes()"
                class="fs-searchfield"
                label="Pesquisar"
                placeholder="Pesquisa por Código(ERP), Razão Social, CNPJ, Contato e E-mail"
                spellcheck="false"
                v-model="textoPesquisaClientes"
                append-icon="mdi-magnify"
                @click:append="pesquisarClientes()"
                hide-details
                outlined
                dense
              />
              <v-btn class="ml-2 primary" style="margin-top: 2px" height="32px" @click="pesquisarClientes()">
                Pesquisar
              </v-btn>
            </v-row>
          </v-form>
          <v-divider class="mb-1"/>
          <v-data-table
            v-show="clientes.data"
            :headers="headersClientes"
            :items="clientes.data"
            :items-per-page="9999999"
            hide-default-footer
            hide-action
            sort-by="id"
            item-key="id"
          >
            <template v-slot:body="{ items }">
              <tr
                v-for="cliente in items"
                :key="cliente.id"
              >
                <td>
                  <v-btn @click="visualizarProdutos(cliente)" icon small><v-icon>mdi-magnify</v-icon></v-btn>
                </td>
                <td>{{ cliente.cliente_id }}</td>
                <td>{{ cliente.cliente_nome }}</td>
                <td>{{ cliente.cliente_cnpj }}</td>
<!--                <td>{{ cliente.ultima_nota_data | formatData }}</td>-->
<!--                <td>{{ cliente.ultima_nota_num }}</td>-->
                <td>{{ cliente.cliente_contato}}</td>
                <td>{{ cliente.cliente_telefone}}</td>
                <td>{{ cliente.cliente_celular }}</td>
                <td>{{ cliente.cliente_email }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <v-overlay :value="loading" z-index="5000">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { list, list2, add, edit, del } from '@/api/crud' // eslint-disable-line
import { buscarClientes, buscarProdutos, enviarPedido } from '@/api/repeticoesPedidos'

import moment from 'moment'

export default {
  data () {
    return {
      headersClientes: [
        { text: 'ITENS', sortable: false },
        { text: 'COD(ERP)', value: 'cliente_id' },
        { text: 'CLIENTE', value: 'cliente_nome' },
        { text: 'CNPJ', value: 'cliente_cnpj' },
        // { text: 'DT.ULT.NFE', value: 'ultima_nota_data' },
        // { text: 'NUM.ULT.NFE', value: 'ultima_nota_num' },
        { text: 'CONTATO', value: 'cliente_contato' },
        { text: 'TELEFONE', value: 'cliente_telefone' },
        { text: 'CELULAR', value: 'cliente_celular' },
        { text: 'E-MAIL', value: 'cliente_email' }
      ],
      headersProdutos: [
        { text: 'NFe', value: 'notafiscal' },
        { text: 'EMISSÃO', value: 'emissao' },
        { text: 'PRODUTO ID', value: 'produto_id' },
        { text: 'PRODUTO', value: 'produto' },
        { text: 'QTDE', value: 'prod_qcom' },
        { text: 'VLR ANTIGO', value: 'valor_antigo' },
        { text: 'VLR ATUAL', value: 'valor_unit_atual' },
        { text: 'SUBTOTAL ANTERIOR', value: 'prod_vprod' },
        { text: 'SUBTOTAL ATUAL', value: 'total_atual' }
      ],
      modalClientes: false,
      clientes: [],
      modalProdutos: false,
      produtos: [],
      produtosSelecionados: [],
      clienteSelecionado: {},
      repeticoes: [],
      textoPesquisaClientes: '',
      textoPesquisa: '',
      loading: false,
      limit: 15,
      page: 1
    }
  },
  filters: {
    formatDataHora (data) {
      return moment(data).format('DD/MM/YYYY - HH:mm')
    },
    formatData (data) {
      return moment(data).format('DD/MM/YYYY')
    },
    formatCurrency (number) {
      number = parseFloat(number).toFixed(2)
      number = number.toString()
      const pattern = /(-?\d+)(\d{3})/
      while (pattern.test(number)) { number = number.replace(pattern, '$1,$2') }
      return 'R$ ' + number
    }
  },
  computed: {
    ...mapState({
      confirm: state => state.global.confirm
    })
  },
  methods: {
    ...mapMutations({
      setSnackbar: 'global/setSnackbar'
    }),
    async pesquisar () {
    },
    async pesquisarClientes () {
      this.loading = true
      if (this.textoPesquisaClientes.length > 0) {
        try {
          this.clientes = await buscarClientes({ txtpesquisa: this.textoPesquisaClientes })
        } catch (error) {
          this.setSnackbar({ msg: error, color: 'red' })
        }
      } else {
        this.setSnackbar({ msg: 'Informe o campo de pesquisa!', color: 'red' })
      }
      this.loading = false
    },
    async visualizarProdutos (cliente) {
      this.loading = true
      this.produtosSelecionados = []
      this.clienteSelecionado = cliente
      try {
        const res = await buscarProdutos({ cliente })
        if (res.data) {
          this.produtos = res
          this.modalProdutos = true
        }
      } catch (error) {
        this.setSnackbar({ msg: error, color: 'red' })
      }
      this.loading = false
    },
    async repetirPedido () {
      this.loading = true
      try {
        await enviarPedido({ cliente: this.clienteSelecionado, produtos: this.produtosSelecionados })
        this.modalProdutos = false
        this.setSnackbar({ msg: 'E-mail Enviado com Sucesso!', color: 'success' })
      } catch (error) {
        this.setSnackbar({ msg: error, color: 'red' })
      }
      this.loading = false
    },
    querySerializePesquisa (nome, filtroComposto) {
      let query = ''
      for (let i = 0; i < filtroComposto.length; i++) {
        if (i === 0) {
          query = query + nome + '%5B0%5D' + '=' + '%5B' + encodeURIComponent(JSON.stringify(filtroComposto[i]))
        } else {
          query = query + encodeURIComponent(',') + encodeURIComponent(JSON.stringify(filtroComposto[i]))
        }
      }
      return query + '%5D'
    }
  }
}
</script>

<style scoped>
#fs-row {
  border-bottom: 1px solid rgba(0,0,0,.12);
}
#fs-row:hover {
  cursor: pointer;
  background-color: rgba(238, 238, 238, 0.712);
}
.fs-searchfield .v-input__icon--append .v-icon {
  margin-top: -6px;
  font-size: 23px !important;
}
.fs-searchfield .v-input__icon--append .v-icon:hover {
  color: black;
}
textarea:focus, input:focus, select:focus, button:focus {
  box-shadow: 0 0 0 0;
  border: 0;
  outline: 0;
}
.row-destaque {
  font-weight: bold;
  border-left: 5px solid red;
}
.fs-btn-limit {
  font-size: 11px !important;
}
.v-input--selection-controls.v-input .v-label {
  padding-top: 9px !important;
  font-size: 12px !important;
}
.fs-topbar-crud {
  text-align: right;
  margin-top: -3px;
}
.fs-btns-crud-grid {
  padding: 3px 7px 3px 7px !important;
  margin-left: 10px;
}
.fs-btns-crud-grid:active {
  border: 1px solid rgb(122, 122, 122) !important;
}
.fs-card-topbar {
  height: 62px;
  border-bottom-right-radius: 0px;
}
.fs-row-campanha-selec {
  background-color: rgba(253, 210, 182, 0.432);
}
</style>
